import React from "react";

// TalentFora mark — inline SVG of the brand icon.
// variant="cream"    → full favicon (dark teal bg rect + ocean mark + coral dot) for dark sidebars/headers
// variant="ocean"    → mark only, no background (for light surfaces)
// (legacy "rust" alias maps to "ocean" for backwards compat)
export default function Logo({ size = 40, variant = "ocean", className = "" }) {
  const wh = { width: `${size}px`, height: `${size}px`, display: "block", flexShrink: 0 };

  if (variant === "cream") {
    // Full favicon — dark teal rect bg + ocean body/head + coral dot.
    // Literal #0f4c5c mirrors the --tf-ocean-icon token; kept literal so this inline
    // SVG stays byte-consistent with the standalone icon .svg files.
    // The raw mark artwork is centered at (524, 675), but the badge rect is centered at
    // (560, 690), so the mark reads ~36 units left and ~15 up. translate(36,15) on the
    // mark group re-centers it inside the badge — matching the apple-touch-icon lockup
    // and the standalone favicon.svg / logo-icon.svg.
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="240 370 640 640"
        width={size} height={size} style={wh} className={className} aria-label="TalentFora">
        <rect x="240" y="370" width="640" height="640" fill="#0f4c5c" rx="110"/>
        <g transform="translate(36,15)">
          <path fill="#1f7d91" d="M709.15,965.76l-361.49.49c-29.7.04-57.82-22.32-56.57-53.64,3.78-94.56,79.63-162.46,171.94-162.02l125.78.6c91.7.44,164.7,67.64,168.43,162.18.84,21.18-22.49,52.36-48.1,52.39Z"/>
          <circle fill="#1f7d91" cx="522.76" cy="607.46" r="105.51"/>
          <circle fill="#e3704f" cx="523.95" cy="437.12" r="53.37"/>
        </g>
      </svg>
    );
  }

  // "ocean" / "rust" / default — mark only on transparent background
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="240 370 640 640"
      width={size} height={size} style={wh} className={className} aria-label="TalentFora">
      <path fill="#1f7d91" d="M709.15,965.76l-361.49.49c-29.7.04-57.82-22.32-56.57-53.64,3.78-94.56,79.63-162.46,171.94-162.02l125.78.6c91.7.44,164.7,67.64,168.43,162.18.84,21.18-22.49,52.36-48.1,52.39Z"/>
      <circle fill="#1f7d91" cx="522.76" cy="607.46" r="105.51"/>
      <circle fill="#e3704f" cx="523.95" cy="437.12" r="53.37"/>
    </svg>
  );
}
